import { useEffect, useState } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useAppSelector } from '@app/store/hooks';
import { CreditApplicationType } from '@app/configs/constants';


export const useIsEnhanceLimit = () => {
  const [isFromEnhanceLimit, setIsFromEnhanceLimit] = useState(false)
  const [isEnhanceOrElevate, setIsEnhanceOrElevate] = useState(false)
  const applicationType = useAppSelector((state) => state.auth.userDetails?.linkedApplications[0]?.applicationType);
  const isApplicationEnhanceType = applicationType === CreditApplicationType.CREDIT_MODIFICATION_AGAINST_SECURITIES;

  const checkIfIsFromEnhanceLimit = async () => {
    const isEnhanceLimit = await AsyncStorage.getItem("application_id") !== null && await AsyncStorage.getItem("isElevate") !== "true" && isApplicationEnhanceType;
    const isEnhanceOrElevate = await AsyncStorage.getItem("application_id") !== null;
    setIsFromEnhanceLimit(isEnhanceLimit)
    setIsEnhanceOrElevate(isEnhanceOrElevate)
  }

  useEffect(() => {
    checkIfIsFromEnhanceLimit();
  }, []);

  return { isFromEnhanceLimit, isEnhanceOrElevate };
};